/* CAFFREY Comfort Max — page behaviour. Second pass v1 (Claude Code, 2026-10-07). Same behaviour as the Walk On Air page
   (Alex: "everything has to be the same, but in a unique way of its own"), Comfort Max's own elements:
   <cf-max-gallery>  four real photos in one frame: arrows + hexagon dots SLIDE them (animated); swipe, arrow keys; snaps.
   <cf-max-buy>      plain EU size radios -> the form's hidden [name=id] (+ bubbling change, KIT.md §4a), price, Add to cart
                     state, ?variant= URL, quantity stepper, size-table highlight, the size-chart sheet. Nothing
                     preselected: Add to cart, Shop Pay (guard) and the kit sticky bar ask for a size first.
   <cf-max-jobs>     "Four jobs, one pair.": every lime ring and every chip opens its own card; one pulse on first view;
                     the anatomy photo and the card's lens (same photo, zoomed) load ~400 px before the section scrolls in.
   <cf-max-sweep>    the box's green swoosh as a FAN of hairlines: parallel lines that converge at both ends and widen in
                     the middle (they never cross — Walk On Air's ribbons twist), lime -> carton green -> deep green, two
                     brighter lime "stripe" lines like the box's highlight; drawn in once, rising from the lower left.
   Safe to load more than once (defer). No dependencies. prefers-reduced-motion: no pulse, no drawing, no smooth scroll. */
(function () {
  if (window.CfMaxPage) return;
  window.CfMaxPage = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function swapIn(img) { /* srcset before src: one download, the right width */
    var set = img.getAttribute('data-max-srcset');
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', img.getAttribute('data-max-src'));
    img.removeAttribute('data-max-src');
    img.removeAttribute('data-max-srcset');
  }

  /* The Klaviyo pop-up is hidden on this page (cf-cm-max.css); Klaviyo still adds its scroll lock to <body> while it
     thinks the pop-up is open, so release it whenever it appears. */
  (function () {
    var b = document.body;
    if (!b) return;
    var free = function () { if (b.classList.contains('klaviyo-prevent-body-scrolling')) b.classList.remove('klaviyo-prevent-body-scrolling'); };
    free();
    if ('MutationObserver' in window) new MutationObserver(free).observe(b, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ---------------- gallery: arrows + hexagon dots over a snapping strip ---------------- */
  class MaxGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.track = this.querySelector('[data-max-slides]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-max-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-max-dot]'));
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.setAttribute('data-enhanced', '');
      var prev = this.querySelector('[data-max-prev]');
      var next = this.querySelector('[data-max-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
      });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking || self._raf) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = self.track.clientWidth || 1;
          self.mark(Math.round(self.track.scrollLeft / w));
        });
      }, { passive: true });
      /* photos 2-4: fetched once the page has loaded (or at the first touch of the gallery), so a tap never shows a gap */
      var warm = function () { self.slides.forEach(function (s) { var img = s.querySelector('img[data-max-src]'); if (img) swapIn(img); }); };
      if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', function () { setTimeout(warm, 300); }, { once: true });
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { self.addEventListener(ev, warm, { once: true, passive: true }); });
    }
    /* the photo visibly slides (ease-out ~0.5 s) with snapping paused until it lands; reduced motion: instant */
    go(i) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      this.mark(i);
      var self = this, track = this.track;
      var from = track.scrollLeft, to = i * track.clientWidth;
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
      if (reduced() || Math.abs(to - from) < 2) { track.scrollLeft = to; return; }
      var dur = Math.min(900, 480 + 120 * Math.abs(to - from) / (track.clientWidth || 1));
      var t0 = null;
      track.style.scrollSnapType = 'none';
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - t, 3);
        track.scrollLeft = from + (to - from) * e;
        if (t < 1) { self._raf = requestAnimationFrame(step); return; }
        self._raf = null;
        track.scrollLeft = to;
        track.style.scrollSnapType = '';
      };
      this._raf = requestAnimationFrame(step);
    }
    mark(i) {
      if (i === this.index && this._marked) return;
      this._marked = true;
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      var k = this.index;
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', String(j === k)); });
    }
  }

  /* ---------------- buy box: size radios -> kit-compatible product form ----------------
     No size is preselected: only the shopper or a ?variant= link chooses one. Until then the main "Add to cart" asks for a
     size (message under the sizes, scroll, focus); Shop Pay is covered by a transparent guard button that asks too
     (Shopify greys its button while the form has no id, and a disabled button fires no click); the kit sticky bar reads
     "Choose your size" with an active "Add to cart" that presses the main button. */
  class MaxBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.qty = this.form.querySelector('input[name="quantity"]');
      this.msg = this.querySelector('[data-max-size-msg]');
      this.sizes = this.querySelector('[data-max-sizes]');
      this.guard = this.querySelector('[data-max-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[data-max-size]'));
      this.unit = 'eu';
      this.usSizes = Object.create(null);
      this.setupUnitToggle();
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-max-size]')) self.select(e.target, true);
      });
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-max-qty]');
        if (!b || !self.qty) return;
        var min = parseInt(self.qty.min, 10) || 1;
        self.qty.value = Math.max(min, (parseInt(self.qty.value, 10) || min) + Number(b.getAttribute('data-max-qty')));
        self.qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no size chosen, a click
         anywhere in the payment block asks for a size instead. */
      var pay = this.querySelector('[data-max-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-max-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      this.chart();
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    /* "Size chart" opens the box's chart right here (a sheet), cloned from the Description's Size chart row; without
       <dialog> support (or without that section) the link simply jumps to the row (opened, below). */
    setupUnitToggle() {
      var self = this;
      var group = this.querySelector('[data-max-units]');
      if (!group) return;
      each(document.querySelectorAll('[data-max-chart-src] [data-max-row]'), function (row) {
        var cells = row.querySelectorAll('th, td');
        if (cells.length < 3) return;
        var parts = [];
        [1, 2].forEach(function (i) {
          var value = cells[i].textContent.replace(/\s*\(EU\s+[^)]+\)/gi, '').trim();
          if (value && value !== '—' && value !== '-') parts.push((i === 1 ? self.dataset.usWomen : self.dataset.usMen) + ' ' + value);
        });
        if (parts.length) self.usSizes[row.getAttribute('data-max-row')] = parts;
      });
      if (!this.radios.every(function (r) { return self.usSizes[r.getAttribute('data-title')]; })) return;
      group.hidden = false;
      group.addEventListener('click', function (event) {
        var button = event.target.closest('[data-max-unit]');
        if (button) self.setUnit(button.getAttribute('data-max-unit'));
      });
      this.setUnit('eu');
    }
    setUnit(unit) {
      if (unit !== 'eu' && unit !== 'us') return;
      var self = this;
      this.unit = unit;
      each(this.querySelectorAll('[data-max-unit]'), function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-max-unit') === unit));
      });
      var heading = this.querySelector('[data-max-size-heading]');
      if (heading) heading.textContent = this.dataset.sizeLabel;
      var legend = this.querySelector('[data-max-size-legend]');
      if (legend) legend.textContent = this.dataset.sizeLabel + ' (' + unit.toUpperCase() + ')';
      this.radios.forEach(function (r) {
        var label = r.nextElementSibling;
        var value = label && label.querySelector('[data-max-size-value]');
        if (!value) return;
        value.replaceChildren();
        value.classList.toggle('cf-max-us-size', unit === 'us');
        if (unit === 'eu') value.textContent = r.getAttribute('data-label');
        else (self.usSizes[r.getAttribute('data-title')] || []).forEach(function (part) {
          var line = document.createElement('span');
          line.textContent = part;
          value.appendChild(line);
        });
      });
      this.patchSticky();
    }
    chart() {
      var self = this;
      var open = this.querySelector('[data-max-chart-open]');
      var dlg = document.querySelector('[data-max-chart-dialog]');
      if (!open || !dlg || typeof dlg.showModal !== 'function') return;
      open.addEventListener('click', function (e) {
        if (!self.fillChart(dlg)) return;
        e.preventDefault();
        self._chartTrigger = open;
        dlg.showModal();
        var r = self.current();
        self.highlight(r ? r.getAttribute('data-title') : null);
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || (e.target.closest && e.target.closest('[data-max-chart-close]'))) dlg.close();
      });
      dlg.addEventListener('close', function () { if (self._chartTrigger) self._chartTrigger.focus(); });
    }
    fillChart(dlg) {
      var slot = dlg.querySelector('[data-max-chart-slot]');
      if (!slot) return false;
      if (slot.childElementCount) return true;
      var src = document.querySelector('[data-max-chart-src]');
      if (!src) return false;
      var c = src.cloneNode(true);
      c.removeAttribute('data-max-chart-src');
      each(c.querySelectorAll('img'), function (img) { img.loading = 'eager'; });
      slot.appendChild(c);
      return true;
    }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    highlight(title) {
      each(document.querySelectorAll('[data-max-row]'), function (tr) {
        tr.classList.toggle('is-current', title !== null && tr.getAttribute('data-max-row') === title);
      });
    }
    none() {
      var any = !!this.firstAvailable();
      this.setId('');
      this.highlight(null);
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = !any;
      this.patchSticky();
    }
    select(r, byUser) {
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) each(document.querySelectorAll('[data-max-price]'), function (el) { el.textContent = price; });
      this.highlight(r.getAttribute('data-title'));
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = true;
      this.clearAsk();
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }
    /* "Choose your size first.": message under the sizes, sizes highlighted, scrolled into view, first size focused. */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = this.dataset.sizeError || '';
        this.msg.hidden = false;
      }
      if (this.sizes) {
        this.sizes.classList.remove('is-asking');
        void this.sizes.offsetWidth; /* restart the highlight when asked again */
        this.sizes.classList.add('is-asking');
        var box = this.sizes.getBoundingClientRect();
        if (box.top < 72 || box.bottom > window.innerHeight - 96) {
          this.sizes.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.sizes) this.sizes.classList.remove('is-asking');
    }
    /* The kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it reads "Unavailable". */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      if (r) {
        var us = this.usSizes[r.getAttribute('data-title')];
        var want = this.unit === 'us' && us ? 'US ' + us.join(' / ') : (this.dataset.prefix || '') + (r.getAttribute('data-label') || r.getAttribute('data-title') || '');
        if (v && v.textContent !== want) v.textContent = want;
        return; /* availability: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      if (btn && btn.disabled) btn.disabled = false;
      if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
      if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
    }
  }

  /* ---------------- "Four jobs, one pair." ---------------- */
  class MaxJobs extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.rings = Array.prototype.slice.call(this.querySelectorAll('.cf-max-ring[data-max-zone]'));
      this.chips = Array.prototype.slice.call(this.querySelectorAll('.cf-max-chip[data-max-zone]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-max-panel]'));
      this.lens = this.querySelector('[data-max-lens]');
      this.lazyImages();
      if (!this.chips.length || !this.panels.length) return;
      this.setAttribute('data-enhanced', '');
      var group = this.querySelector('[data-max-chips]');
      if (group) group.hidden = false;
      var hint = this.querySelector('[data-max-hint]');
      if (hint) hint.hidden = false;

      this.rings.concat(this.chips).forEach(function (t) {
        t.addEventListener('click', function () { self.show(t.getAttribute('data-max-zone')); });
      });
      this.chips.forEach(function (c, i) {
        c.addEventListener('keydown', function (e) {
          if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
          e.preventDefault();
          var n = self.chips.length;
          var j = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + n) % n;
          self.show(self.chips[j].getAttribute('data-max-zone'));
          self.chips[j].focus();
        });
      });
      this.addEventListener('shopify:block:select', function (e) {
        var p = e.target.closest && e.target.closest('[data-max-zone]');
        if (p) self.show(p.getAttribute('data-max-zone'));
      });
      if ('IntersectionObserver' in window && !reduced()) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting || self._pulsed || en.intersectionRatio < 0.35) return;
            self._pulsed = true;
            self.setAttribute('data-pulse', '');
            self.io.disconnect();
          });
        }, { threshold: [0, 0.35] });
        this.io.observe(this);
      }
      this.show(this.getAttribute('data-zone') || 'heel');
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.lio) this.lio.disconnect();
      this._init = false;
    }
    /* the anatomy photo and the card's lens (the same photo, zoomed): ~400 px before the section scrolls into view */
    lazyImages() {
      var self = this;
      var imgs = Array.prototype.slice.call(this.querySelectorAll('img[data-max-src]'));
      var load = function () {
        imgs.forEach(swapIn);
        imgs = [];
        if (self.lens && !self._lens) {
          self._lens = true;
          var url = self.lens.getAttribute('data-max-lens'), low = self.lens.getAttribute('data-max-lens-1x');
          if (low && (window.devicePixelRatio || 1) < 1.5) url = low;
          if (url) self.lens.style.backgroundImage = 'url("' + url + '")';
        }
        if (self.lio) { self.lio.disconnect(); self.lio = null; }
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      this.lio = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) load();
      }, { rootMargin: '400px 0px 400px 0px' });
      this.lio.observe(this);
    }
    show(zone) {
      if (!zone) return;
      this.setAttribute('data-zone', zone);
      this.chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-max-zone') === zone)); });
      this.rings.forEach(function (r) { r.toggleAttribute('data-on', r.getAttribute('data-max-zone') === zone); });
      this.panels.forEach(function (p) { p.hidden = p.getAttribute('data-max-panel') !== zone; });
    }
  }

  /* ---------------- the box's swoosh: a fan of hairlines ----------------
     Each set follows one curve (cubic Bézier segments, drawn from the lower left). n lines are spread across the curve's
     normal by a width that is 0 at both ends and widest in the middle (sin), so the lines converge like the stripes of
     the swoosh on the box and never cross. Two brighter lines (the box's light stripe) run inside the fan.
     Strokes stay ~1.1 CSS px at any size (--cf-max-sw). */
  var SWEEPS = {
    hero: {
      vb: [1000, 1000],
      segs: [[-140, 1010, 230, 990, 600, 930, 805, 735], [805, 735, 1000, 545, 1060, 330, 1150, 150]],
      grad: [-100, 1000, 1120, 160],
      n: 26, w: 230, lift: 0.1,
      hi: [-0.22, 0.31]
    },
    feel: {
      vb: [1600, 720],
      segs: [[-120, 610, 380, 690, 820, 620, 1080, 480], [1080, 480, 1300, 360, 1480, 260, 1740, 200]],
      grad: [-100, 640, 1700, 220],
      n: 18, w: 150, lift: 0.05,
      hi: [0.27]
    }
  };
  function bez(s, t) {
    var u = 1 - t;
    return [u * u * u * s[0] + 3 * u * u * t * s[2] + 3 * u * t * t * s[4] + t * t * t * s[6],
            u * u * u * s[1] + 3 * u * u * t * s[3] + 3 * u * t * t * s[5] + t * t * t * s[7]];
  }
  function onCurve(segs, t) {
    var n = segs.length, i = Math.min(Math.floor(t * n), n - 1);
    return bez(segs[i], t * n - i);
  }
  function normal(segs, t) {
    var a = onCurve(segs, Math.max(0, t - 0.001)), b = onCurve(segs, Math.min(1, t + 0.001));
    var dx = b[0] - a[0], dy = b[1] - a[1], L = Math.sqrt(dx * dx + dy * dy) || 1;
    return [-dy / L, dx / L];
  }
  function smooth(p) { /* Catmull-Rom through the samples -> cubic Béziers */
    var f = function (v) { return Math.round(v * 10) / 10; };
    var d = 'M' + f(p[0][0]) + ' ' + f(p[0][1]);
    for (var i = 0; i < p.length - 1; i++) {
      var p0 = p[Math.max(0, i - 1)], p1 = p[i], p2 = p[i + 1], p3 = p[Math.min(p.length - 1, i + 2)];
      d += 'C' + f(p1[0] + (p2[0] - p0[0]) / 6) + ' ' + f(p1[1] + (p2[1] - p0[1]) / 6) + ' ' +
        f(p2[0] - (p3[0] - p1[0]) / 6) + ' ' + f(p2[1] - (p3[1] - p1[1]) / 6) + ' ' + f(p2[0]) + ' ' + f(p2[1]);
    }
    return d;
  }
  function fanLine(cfg, s) { /* s in [-1, 1]: position across the fan */
    var pts = [], samples = 18;
    for (var k = 0; k <= samples; k++) {
      var t = k / samples;
      var spread = Math.pow(Math.sin(Math.PI * Math.min(1, Math.max(0, (t - 0.02) / 0.96))), 0.85);
      var c = onCurve(cfg.segs, t), nn = normal(cfg.segs, t);
      var off = cfg.w * 0.5 * s * spread + cfg.w * cfg.lift * spread;
      pts.push([c[0] + nn[0] * off, c[1] + nn[1] * off]);
    }
    return smooth(pts);
  }
  var sweepId = 0;
  class MaxSweep extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var cfg = SWEEPS[this.getAttribute('data-set')] || SWEEPS.hero;
      var id = 'cfms' + (++sweepId), g = cfg.grad;
      var svg = '<svg viewBox="0 0 ' + cfg.vb[0] + ' ' + cfg.vb[1] + '" preserveAspectRatio="xMidYMid slice" focusable="false"><defs>' +
        '<linearGradient id="' + id + 'a" gradientUnits="userSpaceOnUse" x1="' + g[0] + '" y1="' + g[1] + '" x2="' + g[2] + '" y2="' + g[3] + '">' +
        '<stop offset=".04" stop-color="#c3d82a" stop-opacity="0"/><stop offset=".22" stop-color="#c3d82a" stop-opacity=".95"/>' +
        '<stop offset=".5" stop-color="#6fca1e"/><stop offset=".78" stop-color="#2f8a18" stop-opacity=".9"/>' +
        '<stop offset="1" stop-color="#1f5f14" stop-opacity="0"/></linearGradient>' +
        '<linearGradient id="' + id + 'b" gradientUnits="userSpaceOnUse" x1="' + g[0] + '" y1="' + g[1] + '" x2="' + g[2] + '" y2="' + g[3] + '">' +
        '<stop offset=".1" stop-color="#d4e64a" stop-opacity="0"/><stop offset=".35" stop-color="#c3d82a"/>' +
        '<stop offset=".7" stop-color="#9fd22a" stop-opacity=".85"/><stop offset=".95" stop-color="#9fd22a" stop-opacity="0"/></linearGradient></defs>';
      var k = 0;
      svg += '<g stroke="url(#' + id + 'a)">';
      for (var i = 0; i < cfg.n; i++) {
        svg += '<path d="' + fanLine(cfg, -1 + 2 * i / (cfg.n - 1)) + '" pathLength="1" style="--i:' + (k++) + '"/>';
      }
      svg += '</g><g class="cf-max-sweep__hi" stroke="url(#' + id + 'b)">';
      cfg.hi.forEach(function (s) {
        svg += '<path d="' + fanLine(cfg, s) + '" pathLength="1" style="--i:' + (k++) + '"/>';
      });
      this.innerHTML = svg + '</g></svg>';
      var self = this;
      /* hairlines: ~1.1 CSS px whatever the drawing's size ("slice": the larger scale wins) */
      var fit = function () {
        var w = self.clientWidth, h = self.clientHeight;
        if (w && h) self.style.setProperty('--cf-max-sw', (1.1 / Math.max(w / cfg.vb[0], h / cfg.vb[1])).toFixed(2));
      };
      fit();
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(this);
      if (reduced() || !('IntersectionObserver' in window)) { this.setAttribute('data-drawn', ''); return; }
      this.setAttribute('data-draw', '');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) return;
        io.disconnect();
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.setAttribute('data-drawn', ''); }); });
      }, { threshold: 0.15 });
      io.observe(this);
    }
  }

  /* The desktop "Size" link (and any #cf-max-size link) opens the Description's Size chart row. */
  (function () {
    var openRow = function () { var d = document.querySelector('[data-max-size-row]'); if (d && !d.open) d.open = true; };
    if (window.location.hash === '#cf-max-size') openRow();
    window.addEventListener('hashchange', function () { if (window.location.hash === '#cf-max-size') openRow(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#cf-max-size"]');
      if (a && !a.hasAttribute('data-max-chart-open')) openRow();
    });
  })();

  [['cf-max-gallery', MaxGallery], ['cf-max-buy', MaxBuy], ['cf-max-jobs', MaxJobs], ['cf-max-sweep', MaxSweep]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });
})();
